import { ThemeProvider } from "@modernatx-internal/ui-kit-react";
import type { AppProps } from "next/app";
import React from "react";

const App: React.FC<AppProps> = ({ Component, pageProps }) => {
  return (
    <ThemeProvider language={pageProps.experience?.language?.iso2}>
      <Component {...pageProps} />
    </ThemeProvider>
  );
};

export default App;
